/**
 * The home for location oriented utilities.
 *
 * This namespace is dependent on the SaCookies namespace.
 */
namespace SaLocationUtils {
    export const FORM_COUNTRY_SELECT_ID = "country";
    /** For certain countries, we display a select/dropdown for State/Province */
    export const FORM_STATE_PROVINCE_SELECT_ID = "state_province";
    /** For certain countries, we display an input for State/Province. The select also stores its value here. */
    export const FORM_STATE_PROVINCE_INPUT_ID = "state_province_value";
    /** The asterisk span indicating that the State/Province field is required */
    export const FORM_STATE_PROVINCE_REQUIRED_ASTERISK_ID = "state_required";

    export enum StateCodeUs {
        AL = "AL",
        AK = "AK",
        AZ = "AZ",
        AR = "AR",
        CA = "CA",
        CO = "CO",
        CT = "CT",
        DE = "DE",
        DC = "DC",
        FL = "FL",
        GA = "GA",
        HI = "HI",
        ID = "ID",
        IL = "IL",
        IN = "IN",
        IA = "IA",
        KS = "KS",
        KY = "KY",
        LA = "LA",
        ME = "ME",
        MD = "MD",
        MA = "MA",
        MI = "MI",
        MN = "MN",
        MS = "MS",
        MO = "MO",
        MT = "MT",
        NE = "NE",
        NV = "NV",
        NH = "NH",
        NJ = "NJ",
        NM = "NM",
        NY = "NY",
        NC = "NC",
        ND = "ND",
        OH = "OH",
        OK = "OK",
        OR = "OR",
        PA = "PA",
        RI = "RI",
        SC = "SC",
        SD = "SD",
        TN = "TN",
        TX = "TX",
        UT = "UT",
        VT = "VT",
        VA = "VA",
        WA = "WA",
        WV = "WV",
        WI = "WI",
        WY = "WY",
    }

    export enum StateCodeCa {
        AB = "AB",
        BC = "BC",
        MB = "MB",
        NB = "NB",
        NL = "NL",
        NS = "NS",
        ON = "ON",
        PE = "PE",
        QC = "QC",
        SK = "SK",
    }

    export enum StateCodeIndia {
        AN = "AN",
        AP = "AP",
        AR = "AR",
        AS = "AS",
        BR = "BR",
        CH = "CH",
        CT = "CT",
        DN = "DN",
        DD = "DD",
        DL = "DL",
        GA = "GA",
        GJ = "GJ",
        HR = "HR",
        HP = "HP",
        JK = "JK",
        JH = "JH",
        KA = "KA",
        KL = "KL",
        LA = "LA",
        LD = "LD",
        MP = "MP",
        MH = "MH",
        MN = "MN",
        ML = "ML",
        MZ = "MZ",
        NL = "NL",
        OR = "OR",
        PY = "PY",
        PB = "PB",
        RJ = "RJ",
        SK = "SK",
        TN = "TN",
        TG = "TG",
        TR = "TR",
        UP = "UP",
        UT = "UT",
        WB = "WB",
    }

    export enum CountryCode {
        AF = "AF",
        AX = "AX",
        AL = "AL",
        DZ = "DZ",
        AS = "AS",
        AD = "AD",
        AO = "AO",
        AI = "AI",
        AQ = "AQ",
        AG = "AG",
        AR = "AR",
        AM = "AM",
        AW = "AW",
        AU = "AU",
        AT = "AT",
        AZ = "AZ",
        BS = "BS",
        BH = "BH",
        BD = "BD",
        BB = "BB",
        BY = "BY",
        BE = "BE",
        BZ = "BZ",
        BJ = "BJ",
        BM = "BM",
        BT = "BT",
        BO = "BO",
        BQ = "BQ",
        BA = "BA",
        BW = "BW",
        BV = "BV",
        BR = "BR",
        IO = "IO",
        BN = "BN",
        BG = "BG",
        BF = "BF",
        BI = "BI",
        CV = "CV",
        KH = "KH",
        CM = "CM",
        CA = "CA",
        KY = "KY",
        CF = "CF",
        TD = "TD",
        CL = "CL",
        CN = "CN",
        CX = "CX",
        CC = "CC",
        CO = "CO",
        KM = "KM",
        CG = "CG",
        CD = "CD",
        CK = "CK",
        CR = "CR",
        CI = "CI",
        HR = "HR",
        CU = "CU",
        CW = "CW",
        CY = "CY",
        CZ = "CZ",
        DK = "DK",
        DJ = "DJ",
        DM = "DM",
        DO = "DO",
        EC = "EC",
        EG = "EG",
        SV = "SV",
        GQ = "GQ",
        ER = "ER",
        EE = "EE",
        SZ = "SZ",
        ET = "ET",
        FK = "FK",
        FO = "FO",
        FJ = "FJ",
        FI = "FI",
        FR = "FR",
        GF = "GF",
        PF = "PF",
        TF = "TF",
        GA = "GA",
        GM = "GM",
        GE = "GE",
        DE = "DE",
        GH = "GH",
        GI = "GI",
        GR = "GR",
        GL = "GL",
        GD = "GD",
        GP = "GP",
        GU = "GU",
        GT = "GT",
        GG = "GG",
        GN = "GN",
        GW = "GW",
        GY = "GY",
        HT = "HT",
        HM = "HM",
        VA = "VA",
        HN = "HN",
        HK = "HK",
        HU = "HU",
        IS = "IS",
        IN = "IN",
        ID = "ID",
        IR = "IR",
        IQ = "IQ",
        IE = "IE",
        IM = "IM",
        IL = "IL",
        IT = "IT",
        JM = "JM",
        JP = "JP",
        JE = "JE",
        JO = "JO",
        KZ = "KZ",
        KE = "KE",
        KI = "KI",
        KW = "KW",
        KG = "KG",
        LA = "LA",
        LV = "LV",
        LB = "LB",
        LS = "LS",
        LR = "LR",
        LY = "LY",
        LI = "LI",
        LT = "LT",
        LU = "LU",
        MO = "MO",
        MG = "MG",
        MW = "MW",
        MY = "MY",
        MV = "MV",
        ML = "ML",
        MT = "MT",
        MH = "MH",
        MQ = "MQ",
        MR = "MR",
        MU = "MU",
        YT = "YT",
        MX = "MX",
        FM = "FM",
        MD = "MD",
        MC = "MC",
        MN = "MN",
        ME = "ME",
        MS = "MS",
        MA = "MA",
        MZ = "MZ",
        MM = "MM",
        NA = "NA",
        NR = "NR",
        NP = "NP",
        NL = "NL",
        NC = "NC",
        NZ = "NZ",
        NI = "NI",
        NE = "NE",
        NG = "NG",
        NU = "NU",
        NF = "NF",
        KP = "KP",
        MK = "MK",
        MP = "MP",
        NO = "NO",
        OM = "OM",
        PK = "PK",
        PW = "PW",
        PS = "PS",
        PA = "PA",
        PG = "PG",
        PY = "PY",
        PE = "PE",
        PH = "PH",
        PN = "PN",
        PL = "PL",
        PT = "PT",
        PR = "PR",
        QA = "QA",
        XK = "XK",
        RE = "RE",
        RO = "RO",
        RU = "RU",
        RW = "RW",
        BL = "BL",
        SH = "SH",
        KN = "KN",
        LC = "LC",
        MF = "MF",
        PM = "PM",
        VC = "VC",
        WS = "WS",
        SM = "SM",
        ST = "ST",
        SA = "SA",
        SN = "SN",
        RS = "RS",
        SC = "SC",
        SL = "SL",
        SG = "SG",
        SX = "SX",
        SK = "SK",
        SI = "SI",
        SB = "SB",
        SO = "SO",
        ZA = "ZA",
        GS = "GS",
        KR = "KR",
        SS = "SS",
        ES = "ES",
        LK = "LK",
        SD = "SD",
        SR = "SR",
        SJ = "SJ",
        SE = "SE",
        CH = "CH",
        SY = "SY",
        TW = "TW",
        TJ = "TJ",
        TZ = "TZ",
        TH = "TH",
        TL = "TL",
        TG = "TG",
        TK = "TK",
        TO = "TO",
        TT = "TT",
        TN = "TN",
        TR = "TR",
        TM = "TM",
        TC = "TC",
        TV = "TV",
        UG = "UG",
        UA = "UA",
        AE = "AE",
        GB = "GB",
        US = "US",
        UM = "UM",
        UY = "UY",
        UZ = "UZ",
        VU = "VU",
        VE = "VE",
        VN = "VN",
        VG = "VG",
        VI = "VI",
        WF = "WF",
        EH = "EH",
        YE = "YE",
        ZM = "ZM",
        ZW = "ZW",
    }

    export interface StateOption {
        value: string;
        text: string;
    }

    const stateData: { [key in CountryCode]?: StateOption[] } = {
        [CountryCode.US]: [
            { value: StateCodeUs.AL, text: "Alabama" },
            { value: StateCodeUs.AK, text: "Alaska" },
            { value: StateCodeUs.AZ, text: "Arizona" },
            { value: StateCodeUs.AR, text: "Arkansas" },
            { value: StateCodeUs.CA, text: "California" },
            { value: StateCodeUs.CO, text: "Colorado" },
            { value: StateCodeUs.CT, text: "Connecticut" },
            { value: StateCodeUs.DE, text: "Delaware" },
            { value: StateCodeUs.DC, text: "District of Columbia" },
            { value: StateCodeUs.FL, text: "Florida" },
            { value: StateCodeUs.GA, text: "Georgia" },
            { value: StateCodeUs.HI, text: "Hawaii" },
            { value: StateCodeUs.ID, text: "Idaho" },
            { value: StateCodeUs.IL, text: "Illinois" },
            { value: StateCodeUs.IN, text: "Indiana" },
            { value: StateCodeUs.IA, text: "Iowa" },
            { value: StateCodeUs.KS, text: "Kansas" },
            { value: StateCodeUs.KY, text: "Kentucky" },
            { value: StateCodeUs.LA, text: "Louisiana" },
            { value: StateCodeUs.ME, text: "Maine" },
            { value: StateCodeUs.MD, text: "Maryland" },
            { value: StateCodeUs.MA, text: "Massachusetts" },
            { value: StateCodeUs.MI, text: "Michigan" },
            { value: StateCodeUs.MN, text: "Minnesota" },
            { value: StateCodeUs.MS, text: "Mississippi" },
            { value: StateCodeUs.MO, text: "Missouri" },
            { value: StateCodeUs.MT, text: "Montana" },
            { value: StateCodeUs.NE, text: "Nebraska" },
            { value: StateCodeUs.NV, text: "Nevada" },
            { value: StateCodeUs.NH, text: "New Hampshire" },
            { value: StateCodeUs.NJ, text: "New Jersey" },
            { value: StateCodeUs.NM, text: "New Mexico" },
            { value: StateCodeUs.NY, text: "New York" },
            { value: StateCodeUs.NC, text: "North Carolina" },
            { value: StateCodeUs.ND, text: "North Dakota" },
            { value: StateCodeUs.OH, text: "Ohio" },
            { value: StateCodeUs.OK, text: "Oklahoma" },
            { value: StateCodeUs.OR, text: "Oregon" },
            { value: StateCodeUs.PA, text: "Pennsylvania" },
            { value: StateCodeUs.RI, text: "Rhode Island" },
            { value: StateCodeUs.SC, text: "South Carolina" },
            { value: StateCodeUs.SD, text: "South Dakota" },
            { value: StateCodeUs.TN, text: "Tennessee" },
            { value: StateCodeUs.TX, text: "Texas" },
            { value: StateCodeUs.UT, text: "Utah" },
            { value: StateCodeUs.VT, text: "Vermont" },
            { value: StateCodeUs.VA, text: "Virginia" },
            { value: StateCodeUs.WA, text: "Washington" },
            { value: StateCodeUs.WV, text: "West Virginia" },
            { value: StateCodeUs.WI, text: "Wisconsin" },
            { value: StateCodeUs.WY, text: "Wyoming" },
        ],
        [CountryCode.CA]: [
            { value: StateCodeCa.AB, text: "Alberta" },
            { value: StateCodeCa.BC, text: "British Columbia" },
            { value: StateCodeCa.MB, text: "Manitoba" },
            { value: StateCodeCa.NB, text: "New Brunswick" },
            { value: StateCodeCa.NL, text: "Newfoundland and Labrador" },
            { value: StateCodeCa.NS, text: "Nova Scotia" },
            { value: StateCodeCa.ON, text: "Ontario" },
            { value: StateCodeCa.PE, text: "Prince Edward Island" },
            { value: StateCodeCa.QC, text: "Quebec" },
            { value: StateCodeCa.SK, text: "Saskatchewan" },
        ],
        [CountryCode.IN]: [
            { value: StateCodeIndia.AN, text: "Andaman and Nicobar Islands" },
            { value: StateCodeIndia.AP, text: "Andhra Pradesh" },
            { value: StateCodeIndia.AR, text: "Arunachal Pradesh" },
            { value: StateCodeIndia.AS, text: "Assam" },
            { value: StateCodeIndia.BR, text: "Bihar" },
            { value: StateCodeIndia.CH, text: "Chandigarh" },
            { value: StateCodeIndia.CT, text: "Chhattisgarh" },
            { value: StateCodeIndia.DN, text: "Dadra and Nagar Haveli" },
            { value: StateCodeIndia.DD, text: "Daman and Diu" },
            { value: StateCodeIndia.DL, text: "Delhi" },
            { value: StateCodeIndia.GA, text: "Goa" },
            { value: StateCodeIndia.GJ, text: "Gujarat" },
            { value: StateCodeIndia.HR, text: "Haryana" },
            { value: StateCodeIndia.HP, text: "Himachal Pradesh" },
            { value: StateCodeIndia.JK, text: "Jammu and Kashmir" },
            { value: StateCodeIndia.JH, text: "Jharkhand" },
            { value: StateCodeIndia.KA, text: "Karnataka" },
            { value: StateCodeIndia.KL, text: "Kerala" },
            { value: StateCodeIndia.LA, text: "Ladakh" },
            { value: StateCodeIndia.LD, text: "Lakshadweep" },
            { value: StateCodeIndia.MP, text: "Madhya Pradesh" },
            { value: StateCodeIndia.MH, text: "Maharashtra" },
            { value: StateCodeIndia.MN, text: "Manipur" },
            { value: StateCodeIndia.ML, text: "Meghalaya" },
            { value: StateCodeIndia.MZ, text: "Mizoram" },
            { value: StateCodeIndia.NL, text: "Nagaland" },
            { value: StateCodeIndia.OR, text: "Odisha" },
            { value: StateCodeIndia.PY, text: "Puducherry" },
            { value: StateCodeIndia.PB, text: "Punjab" },
            { value: StateCodeIndia.RJ, text: "Rajasthan" },
            { value: StateCodeIndia.SK, text: "Sikkim" },
            { value: StateCodeIndia.TN, text: "Tamil Nadu" },
            { value: StateCodeIndia.TG, text: "Telangana" },
            { value: StateCodeIndia.TR, text: "Tripura" },
            { value: StateCodeIndia.UP, text: "Uttar Pradesh" },
            { value: StateCodeIndia.UT, text: "Uttarakhand" },
            { value: StateCodeIndia.WB, text: "West Bengal" },
        ],
    };

    export const COUNTRIES_WHERE_STATE_IS_REQUIRED: CountryCode[] = [
        CountryCode.US,
        CountryCode.CA,
    ];

    export function setupLocation(): void {
        $(`#${FORM_STATE_PROVINCE_SELECT_ID}`).hide();
        $(`#${FORM_STATE_PROVINCE_INPUT_ID}`).hide();
        $(`#${FORM_STATE_PROVINCE_SELECT_ID} option`).hide();
        $(`#${FORM_STATE_PROVINCE_SELECT_ID}`)
            .off("change.saLocation") // This is so multiple event handlers don't get attached if this function is called multiple times
            .on("change.saLocation", function () {
                $(`#${FORM_STATE_PROVINCE_INPUT_ID}`).val(
                    $(`#${FORM_STATE_PROVINCE_SELECT_ID}`).val() as string,
                );
            });

        setupCountryFields();
    }

    export function setupCountryFields(): void {
        const countrySelect = $(`#${FORM_COUNTRY_SELECT_ID}`);
        const stateInput = $(`#${FORM_STATE_PROVINCE_INPUT_ID}`);
        const stateSelect = $(`#${FORM_STATE_PROVINCE_SELECT_ID}`);
        const countryValue = countrySelect.val();
        if (
            COUNTRIES_WHERE_STATE_IS_REQUIRED.includes(
                countryValue as CountryCode,
            )
        ) {
            populateStates(
                `#${FORM_COUNTRY_SELECT_ID}`,
                `#${FORM_STATE_PROVINCE_SELECT_ID}`,
                stateInput.val(),
            );
            stateSelect.show().prop("required", true);

            const stateProvinceValue = stateInput.val();
            if (stateProvinceValue) {
                stateSelect.val(stateProvinceValue);
            }
            stateInput.hide();
            $(`#${FORM_STATE_PROVINCE_REQUIRED_ASTERISK_ID}`)?.show();
        } else {
            populateStates(
                `#${FORM_COUNTRY_SELECT_ID}`,
                `#${FORM_STATE_PROVINCE_SELECT_ID}`,
                stateInput.val(),
            );
            stateInput.show();
            stateSelect.val("").prop("required", false).hide();

            $(`#${FORM_STATE_PROVINCE_REQUIRED_ASTERISK_ID}`)?.hide();
        }
    }

    export function populateStates(
        countrySelector: string,
        stateSelector: string,
        preselectedValue: string | number | string[] | null | undefined = null,
    ): void {
        const country = $(countrySelector).val();
        const $state = $(stateSelector);
        const options =
            country && typeof country === "string"
                ? (stateData[country as CountryCode] ?? [])
                : [];

        $state.empty(); // Clear existing options

        if (options.length > 0) {
            $state.append(
                $("<option>", {
                    value: "",
                    text: "Select",
                }),
            );
        }

        options.forEach((opt) => {
            const $option = $("<option>", {
                value: opt.value,
                text: opt.text,
            });
            $state.append($option);
        });

        if (preselectedValue) {
            $state.val(preselectedValue);
        }
    }
}

globalThis.SaLocationUtils = SaLocationUtils;
